<template>
	<div class="menu_box border_bottom_dashed" style="border-top: none;border-bottom: none;">
		<div class="flex borderBottomDashed paddingAll20 ">
			<div class="title_shaixuan flex_jc_center">更多筛选</div>
			<div>
				<el-form :inline="true" :model="formData" class="demo-form-inline">
					<el-form-item class="select-input">
						<el-select size="small" v-model="formData.verticalType" placeholder="招标方式">
							<el-option v-for="(item, index) in verticalTypeList" :key="index" :label="item.name" :value="item.no">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="select-input">
						<el-select size="small" v-model="formData.price" placeholder="概算金额">
							<el-option v-for="(item, index) in priceList" :key="index" :label="item.name" :value="item.no">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
  import {apiLabour} from "@/api/apiLabour"
	export default {
		name: "verticalTypeAndPice",
    data() {
      return {
        verticalTypeList:[],
        priceList:[],
        formData:{
          verticalType:'',
          price:''
        }
      }
    },
    watch:{
      'formData.verticalType':function (v){
        let obj=this.verticalTypeList.filter(d=>d.no==v);
        if(v!==''&&obj.length){
          this.send(obj[0],'verticalType')
        }
      },
      'formData.price':function (v){
        let obj=this.priceList.filter(d=>d.no==v);
        if(v!==''&&obj.length){
          this.send(obj[0],'price')
        }
      },
    },
    created() {
      this.getVerticalType()
      this.getTenderMoney()
    },
    methods: {
      // 获取报名结束时间
      async getVerticalType() {
        if(!this.$store.state.HC_VerticalType){
          let res = await apiLabour.getTenderTypeBidWay()
          this.data = res.data.result
          this.$store.state.HC_VerticalType = res.data.result
        }else{
          this.data = this.$store.state.HC_VerticalType
        }
      },
      // 获取概算金额
      getTenderMoney() {
        apiLabour.getTenderMoney().then(res => {
          if (res && res.data && res.data.code === 0) {
            this.priceList = res.data.result.filter(el => {return el.no !== ""})
          }
        })
      },
      /** @name 搜索单项 */
      send(obj,key){
        if(key)obj.key=key;
        //替换搜索项
        let type=-1;
        this.$parent.$refs.screen.verticalTypeAndPice.map((d,i)=>{
          if(d.key==key){
            type=i
          }
        });
        if(type>-1) {
          this.$parent.$refs.screen.verticalTypeAndPice.splice(type,1,obj)
          return
        }
        //添加搜索项
        this.$parent.$refs.screen.verticalTypeAndPice.push(obj)
      },
      /** @name 清队单项 */
      close(item){
        this.formData[item.key]=''
      },
      /** @name 清空所有 */
      closeall(){
        this.formData={
          verticalType:'',
          price:''
        }
      }
    },
	}
</script>

<style scoped>

</style>
